import { render, staticRenderFns } from "./DetailsAbsenceByParent.vue?vue&type=template&id=59ff2226&"
import script from "./DetailsAbsenceByParent.vue?vue&type=script&lang=js&"
export * from "./DetailsAbsenceByParent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsAbsenceByParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports